import React, { useEffect, useState, useRef } from 'react'
import constant from "../../../Components/Services/constant";
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css';
import 'swiper/css/navigation';
import { Autoplay } from 'swiper/modules'
import { ApiService } from '../../../Components/Services/apiservices';
function Reels({ dataObj }) {
    const didMountRef = useRef(true);
    const [reels, setReels] = useState([]);
    const [reelsImagePath, setReelsImagePath] = useState("");
    useEffect(() => {
        if (didMountRef.current) {
            getReelsData()
        }
        didMountRef.current = false;
    }, [])

    const getReelsData = () => {
        ApiService.fetchData("reels").then((res) => {
            if (res.status == "success") {
                setReels(res.ReelsData);
                setReelsImagePath(res.ReelsPath);
            }
        })
    }
    const handleSlideChange = () => {
        // document.querySelectorAll(".reel-video").forEach((video) => {
        //     video.pause();
        //     video.currentTime = 0; // Restart from the beginning
        //     video.play();
        // });
    };
    
    const productCarouselOptions = {
        spaceBetween: 15,
        centeredSlides: false,
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        autoplay: {
            delay: 2000,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            0: {
                slidesPerView: 1.5, 
                spaceBetween: 10,
            },
            600: {
                slidesPerView: 1.5, 
                spaceBetween: 15,
            },
            1000: {
                slidesPerView: 4.5, 
                spaceBetween: 15,
            },
        },
    };
    return (
        <>
            {reels?.length > 0 && (
                <>
                    {dataObj.home_display_type == 2 ? (
                        <div>
                            <div className={"row g-3 " + dataObj.home_col_grid + dataObj.home_column}>
                                {reels.map((reel, index) => (
                                   <div class="product product-wvideo">
                                   <figure class="product-media">
                                       <a href={reel.reels_url}>
                                           <video
                                           width="320"
                                           height="240"
                                           autoPlay
                                           loop
                                           muted
                                           playsInline
                                           id={`video-${index}`}
                                       >
                                           <source
                                               src={reel.reels_reels ? reelsImagePath + reel.reels_reels : constant.DEFAULT_IMAGE}
                                               type="video/mp4"
                                           />
                                       </video>
                                       </a>
                                   </figure>
                               </div>
                               
                                ))}
                            </div>
                        </div>
                    ) : (
                        <div>
                            <Swiper {...productCarouselOptions} modules={[Autoplay]}>
                                {reels.map((reel, index) => (
                                    <SwiperSlide key={index}>
                                   <div class="product product-wvideo">
                                        <figure class="product-media">
                                            <a href={reel.reels_url}>
                                                <video
                                                width="320"
                                                height="240"
                                                autoPlay
                                                loop
                                                muted
                                                playsInline
                                                id={`video-${index}`}
                                            >
                                                <source
                                                    src={reel.reels_reels ? reelsImagePath + reel.reels_reels : constant.DEFAULT_IMAGE}
                                                    type="video/mp4"
                                                />
                                            </video>
                                            </a>
                                        </figure>
                                    </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    )}
                </>
            )}


        </>
    )
}

export default Reels
